<dx-form
    [items]="items"
    [(formData)]="formData"
    [validationGroup]="$validationGroupName()"
    [colCount]="1"
    [showValidationSummary]="true">
</dx-form>

@if (loadIndicatorVisible) {
    <app-load-indicator />
}
